import * as signalR from '@microsoft/signalr';
import { useAuthStore } from '@/stores/authStore';
import type { ChatMessage } from '@/lib/api/chat';

const BASE_URL = import.meta.env.VITE_API_URL ?? '/api/v1';
const HUB_URL = `${BASE_URL.replace(/\/api\/v1\/?$/, '')}/hubs/chat`;

export interface ChatPush {
  roomId: string;
  message: ChatMessage;
}

/** Opens the chat hub and invokes `onMessage` for each live message. Returns a disposer. */
export const startChatHub = (onMessage: (push: ChatPush) => void) => {
  const connection = new signalR.HubConnectionBuilder()
    .withUrl(HUB_URL, {
      accessTokenFactory: () => useAuthStore.getState().accessToken ?? '',
    })
    .withAutomaticReconnect()
    .build();

  connection.on('chatMessage', onMessage);
  connection.start().catch(() => { /* offline / auth not ready — REST still works */ });

  return () => { connection.stop().catch(() => undefined); };
};
